<template>
  <header class="app-header">
    <div class="container header-container">
      <!-- 햄버거 버튼 (모바일) -->
      <div class="header-left">
        <button
          aria-label="메뉴 열기/닫기"
          class="menu-toggle mobile-only"
          @click="toggleMenu"
          :class="{ hidden: menuOpen }"
        >
          <span class="hamburger-line"></span
          ><span class="hamburger-line"></span
          ><span class="hamburger-line"></span>
        </button>
        <router-link to="/" class="logo">
          <img :src="logo" alt="ASTOC Logo" />
        </router-link>
      </div>

      <!-- PC 메뉴 -->
      <nav class="main-nav desktop-only">
        <router-link v-for="link in navLinks" :key="link.path" :to="link.path">
          {{ link.text }}
        </router-link>
      </nav>

      <!-- 모바일 메뉴 -->
      <div class="mobile-menu-overlay" v-if="menuOpen" @click="closeMenu"></div>
      <transition name="slide-down">
        <nav v-if="menuOpen" class="mobile-nav">
          <!-- 모바일 메뉴 헤더: 로고와 닫기 버튼 -->
          <div class="mobile-menu-header">
            <router-link to="/" class="mobile-logo" @click.native="closeMenu">
              <img :src="logo" alt="ASTOC Logo" />
            </router-link>
            <button class="close-btn" @click="closeMenu">✕</button>
          </div>
          <router-link
            v-for="link in navLinks"
            :key="link.path"
            :to="link.path"
            @click.native="closeMenu"
          >
            {{ link.text }}
          </router-link>
        </nav>
      </transition>
    </div>
  </header>
</template>

<script>
export default {
  name: "AppHeader",
  data() {
    return {
      // 로고 이미지 경로입니다. 실제 프로젝트 경로에 맞게 수정해주세요.
      logo: require("@/assets/images/astoc.png"),
      navLinks: [
        { text: "회사소개", path: "/about" },
        { text: "사업분야", path: "/business" },
        { text: "고객문의", path: "/contact" },
        /*
        { text: '문의관리', path: '/admin/inquiries' },
        */
      ],
      menuOpen: false,
    };
  },
  methods: {
    closeMenu() {
      this.menuOpen = false;
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
  },
  watch: {
    // 라우트(페이지)가 변경될 때마다 모바일 메뉴를 닫습니다.
    $route() {
      this.closeMenu();
    },
  },
};
</script>

<style scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--header-height);
  background-color: white; /* 헤더 배경을 항상 흰색으로 고정 */
  display: flex;
  align-items: center;
  z-index: 1000;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
}

.header-container {
  display: flex;
  justify-content: space-between; /* 로고와 메뉴를 양쪽 끝으로 정렬 */
  align-items: center;
  width: 100%;
  max-width: 1280px; /* 메인 컨텐츠 너비와 일치 */
  margin: 0 auto; /* 중앙 정렬 */
  padding: 0 20px; /* 좌우 여백 */
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* --- 로고 크기 및 위치 수정 --- */
/* height 값을 조정하여 로고 크기를 변경할 수 있습니다. */
.logo img {
  height: 65px;
  padding-left: 20px; /* 로고를 오른쪽으로 이동시켜 왼쪽 여백 확보 */
}

.logo span {
  font-size: 1.5rem;
  font-weight: 800;
  color: white; /* 기본 텍스트 로고 색상 */
  transition: color 0.3s ease;
}

.main-nav {
  display: flex;
  gap: 40px; /* 메뉴 아이템 간의 간격 */
}
/* 메뉴 색상을 항상 빨간색으로 고정하고, 스크롤 시 색상 변경 로직을 제거합니다. */
.main-nav a {
  color: var(--primary-red); /* 요청에 따라 메뉴 링크 색상을 빨간색으로 고정 */
  text-decoration: none;
  font-weight: 700;
  font-size: 1rem;
  padding: 10px 0;
  position: relative;
  transition: color 0.3s ease;
}
.main-nav a.router-link-exact-active {
  font-weight: 900; /* 활성 메뉴 굵게 표시 */
}
.main-nav a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0%;
  height: 2px;
  background-color: var(--primary-red);
  transition: width 0.3s ease;
}
.main-nav a:hover::after,
.main-nav a.router-link-exact-active::after {
  width: 100%;
}
.desktop-only {
  display: flex;
}

.menu-toggle {
  display: none;
  border: none;
  background: none;
  font-size: 30px;
  cursor: pointer;
  color: var(--primary-blue); /* 아이콘 색상 */
  transition: color 0.3s ease;
}

.mobile-only {
  display: none;
}

/* 메뉴가 열렸을 때 햄버거 버튼 숨김 처리 */
.menu-toggle.hidden {
  visibility: hidden;
}

/* 모바일 메뉴 드롭다운 애니메이션 */
.slide-down-enter-active {
  transition: all 0.3s ease-out;
}
.slide-down-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
.hamburger-line {
  display: block;
  width: 25px;
  height: 2px;
  background-color: currentColor;
  margin: 6px 0;
  transition: background-color 0.3s ease;
}

/* 모바일 화면 대응 */
@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: block;
  }
  .menu-toggle {
    z-index: 1002; /* 메뉴 버튼이 다른 요소 위에 오도록 설정 */
  }

  .header-container {
    justify-content: space-between;
  }

  .mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }

  .mobile-nav {
    position: fixed; /* 화면 전체 기준으로 위치 고정 */
    top: 0;
    left: 0;
    width: 100%;
    height: auto; /* 높이를 컨텐츠에 맞게 자동 조절 */
    background: white;
    display: flex;
    flex-direction: column;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1); /* 아래쪽 그림자 효과로 변경 */
    z-index: 1001;
  }

  .mobile-menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 1rem; /* 상하 패딩 추가 축소 */
    border-bottom: 1px solid #eee;
    /* 로고와 버튼의 수직 정렬을 위해 최소 높이 설정 */
    min-height: auto; /* 높이를 컨텐츠에 맞게 자동 조절 */
  }
  /* 로고 링크의 display 속성을 추가하여 정렬 보정 */
  .mobile-logo {
    display: flex;
    align-items: center;
  }
  .close-btn {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: var(--text-light);
    padding: 0;
  }

  .mobile-logo img {
    height: 35px; /* 로고 크기 추가 축소 */
  }

  .logo img {
    height: 65px;
    padding-left: 0; /* 모바일에서 로고 왼쪽 여백 제거 */
  }

  .mobile-nav a {
    padding: 18px;
    color: var(--primary-red);
    text-decoration: none;
    border-bottom: 1px solid #eee;
    text-align: left; /* 메뉴 텍스트 중앙 정렬 */
    font-weight: 600;
  }

  .mobile-nav a:hover {
    background: #f6f6f6;
  }
}

/* PC 화면에서는 햄버거 버튼 숨김 */
@media (min-width: 769px) {
  .mobile-only {
    display: none;
  }
}
</style>
